export const ItemTypes = Object.freeze({
  JOURNEY_ROW: 'journeyRow',
  LEVEL_ROW: 'levelRow',
  ACTIVITY_ROW: 'activityRow',
  MENTOR_FILE_ROW: 'mentorFileRow',
  RESOURCE_ROW: 'resourceRow'
})



// WEBPACK FOOTER //
// ./src/components/mycourses/Journey/ItemTypes.js